export default "__VITE_ASSET__tyrNfCAX__"